<script>
    import Icon from "../lib/components/icons/Icon.svelte";
</script>

<div class="d-flex align-items-center justify-content-center" style="height: 100vh;">
    <div class="text-center">
        <div class="page-icon mb-4">
            <Icon name="alert-triangle" size="70"/>
        </div>
        <h1 class="mb-3">Reservation not found!</h1>
        <p>
            Unfortunately, we couldn’t locate your booking.
        </p>
        <p>
            Please ensure that the link you entered is correct.
        </p>
    </div>
</div>

<style>
    .page-icon {
        width: 130px;
        height: 130px;
        margin: auto;
        background: #f7f7f7;
        display: flex;
        border-radius: 50%;
    }
</style>